import React from 'react';
import {Grid} from '@material-ui/core'
import {UploadFile, totalUser, leaf, store, openBook} from '../../../assets/images/images'
import './style.scss'

function Index(props) {
  const stats = props.stats || {};
  const data = [
    {id: 1, icon: totalUser, value: stats.happyCustomers ?? '—', title: 'happy customer'},
    {id: 2, icon: openBook, value: stats.stockInventory ?? '—', title: 'Stock Inventory'},
    {id: 3, icon: store, value: stats.ourVendors ?? '—', title: 'Our Vendors'},
    {id: 4, icon: leaf, value: stats.ourServices ?? '—', title: 'Services Listed'},
  ]
  return (
    <Grid container style={{padding: 20}}>
      {/*<Grid className='display-flex'>*/}
      {data.map((item, index) => {
        return (
          <Grid xs={6} md={3} direction='column' container alignItems={'center'} className='p-10 effort-card-container'>
            <img src={item.icon} alt={''} className='in-active-color    img'/>
            <h1 className='heading-color text-bold text-capitalize'>{item.value}</h1>
            <p className='light-black-color font-16 text-center text-capitalize mt-5'>{item.title}</p>
          </Grid>
        )
      })}
      {/*</Grid>*/}
    </Grid>

  );
}

export default Index;
